import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    editing: _ctx.editing,
    "onUpdate:editing": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editing) = $event)),
    title: "Billing address",
    layout: "grid",
    "model-value": _ctx.billingAddress,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:client', _ctx.client.sys.id, { billing_address: { ..._ctx.billingAddress, ...$event } }))),
    "column-count": 1
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("p", null, [
          _createTextVNode("The billing address is automatically the same as the address."),
          _createElementVNode("br"),
          _createTextVNode("Do you want to set another billing address?")
        ], -1)),
        (!_ctx.showFields)
          ? (_openBlock(), _createBlock(_component_d_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = true)),
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_add_icon, { left: "" }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "billing address", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showFields)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_editable_block_input, {
                label: "Street",
                modelValue: editState.street,
                "onUpdate:modelValue": ($event: any) => ((editState.street) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                label: "Number",
                modelValue: editState.street_number,
                "onUpdate:modelValue": ($event: any) => ((editState.street_number) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                label: "Zip code",
                modelValue: editState.zipcode,
                "onUpdate:modelValue": ($event: any) => ((editState.zipcode) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                label: "City",
                modelValue: editState.city,
                "onUpdate:modelValue": ($event: any) => ((editState.city) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_editable_block_input, {
                label: "Country",
                modelValue: editState.country,
                "onUpdate:modelValue": ($event: any) => ((editState.country) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["editing", "model-value"]))
}